<template>
  <div class="container-notification">
    <!--    <div v-for="key in 0" :key="key">-->
    <!--      <div class="d-flex content-notification">-->
    <!--        <div class="img-notification">-->
    <!--          <img src="@/assets/images/main-bg.png" alt="">-->
    <!--        </div>-->
    <!--        <div class="detail-notification">-->
    <!--          <div class="title-notification">-->
    <!--            <span>Jane Cooper</span> has made a bid for your item your item your item-->
    <!--          </div>-->
    <!--          <div class="time-notification">-->
    <!--            19 minutes ago-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="underlined"></div>-->
    <!--      <div></div>-->
    <!--    </div>-->
    No notifications
  </div>
</template>

<script>
export default {
  name: 'Notificaion'
};
</script>

<style lang="scss" scoped>
@import './../assets/style/variables.scss';

.container-notification {
  padding: 30px;
  width: 500px;
  .content-notification {
    .img-notification {
      width: 60px;
      height: 60px;
      margin-right: 16px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .detail-notification {
      .title-notification {
        font-size: 14px;
        line-height: 24px;
        font-weight: 400;
        color: #b7c1dc;

        span {
          color: #203a54;
          font-weight: 600;
        }
      }
      .time-notification {
        font-size: 14px;
        line-height: 20px;
        color: #babfca;
      }
    }
  }
  .underlined {
    margin: 20px 0;
    border: 1px solid #f3f5fa;
  }
}
@media screen and (max-width: $breakpoint-mobile) {
  .container-notification {
    width: 97vw;
    margin: auto;
  }
}
</style>
